import { types as coreTypes } from '@sitebuilder/core';

export interface IListApiClient {
    copyListItem(
        sourceFileId: string,
        destinationFileId: string,
        listType: coreTypes.listType,
        libraryName?: string,
        options?: { originalHostname?: string; accessToken?: string }
    ): Promise<any[]>;

    deleteListItem(
        fileId: string,
        listType: coreTypes.listType,
        libraryName?: string,
        options?: { originalHostname?: string; accessToken?: string }
    ): Promise<any[]>;

    moveListItem(
        sourceFileId: string,
        destinationFileId: string,
        listType: coreTypes.listType,
        libraryName?: string,
        options?: { originalHostname?: string; accessToken?: string }
    ): Promise<any[]>;

    deleteListTagItem(
        fileId: string,
        tag: string,
        listType: coreTypes.listType,
        libraryName?: string,
        options?: { originalHostname?: string; accessToken?: string }
    ): Promise<any[]>;

    addListTagItem(
        fileId: string,
        tag: string,
        listType: coreTypes.listType,
        libraryName?: string,
        options?: { originalHostname?: string; accessToken?: string }
    ): Promise<any[]>;
}

export class ListApiClient implements IListApiClient {
    baseUrl: string;
    constructor(baseUrl: string = '') {
        this.baseUrl = baseUrl;
    }

    private getHeaders(
        h: {
            [key: string]: string;
        },
        options?: { accessToken?: string }
    ) {
        const headers: {
            [key: string]: string;
        } = {};

        if (typeof options?.accessToken === 'string' && options.accessToken.length > 0) {
            headers.Authorization = `bearer ${options.accessToken}`;
        }

        return { ...headers, ...h };
    }

    async copyListItem(
        sourceFileId: string,
        destinationFileId: string,
        listType: coreTypes.listType,
        libraryName?: string,
        options?: { originalHostname?: string; accessToken?: string }
    ) {
        const url = `${this.baseUrl || ''}/api/admin/${listType}/copy`;

        const res = await fetch(url, {
            method: 'POST',
            headers: this.getHeaders(
                {
                    'Content-Type': 'application/json',
                },
                options
            ),
            body: JSON.stringify({
                sourceFileId: sourceFileId,
                destinationFileId: destinationFileId,
                libraryName: libraryName,
            }),
        });

        return await res.json();
    }

    async deleteListItem(
        fileId: string,
        listType: coreTypes.listType,
        libraryName?: string,
        options?: { originalHostname?: string; accessToken?: string }
    ) {
        const url = `${this.baseUrl || ''}/api/admin/${listType}/delete`;
        const res = await fetch(url, {
            method: 'POST',
            headers: this.getHeaders(
                {
                    'Content-Type': 'application/json',
                },
                options
            ),
            body: JSON.stringify({
                fileId: fileId,
                libraryName: libraryName,
            }),
        });

        return await res.json();
    }

    async moveListItem(
        sourceFileId: string,
        destinationFileId: string,
        listType: coreTypes.listType,
        libraryName?: string,
        options?: { originalHostname?: string; accessToken?: string }
    ) {
        const url = `${this.baseUrl || ''}/api/admin/${listType}/move`;

        const res = await fetch(url, {
            method: 'POST',
            headers: this.getHeaders(
                {
                    'Content-Type': 'application/json',
                },
                options
            ),
            body: JSON.stringify({
                sourceFileId: sourceFileId,
                destinationFileId: destinationFileId,
                libraryName: libraryName,
            }),
        });

        return await res.json();
    }

    async deleteListTagItem(
        fileId: string,
        tag: string,
        listType: coreTypes.listType,
        libraryName?: string,
        options?: { originalHostname?: string; accessToken?: string }
    ) {
        // eslint-disable-next-line max-len
        const url = `${process.env.IS_SSR_LOCAL_QUERY_ENDPOINT || ''}/api/admin/${listType}/remove/tags`;
        const res = await fetch(url, {
            method: 'POST',
            headers: this.getHeaders(
                {
                    'Content-Type': 'application/json',
                },
                options
            ),
            body: JSON.stringify({
                fileId: fileId,
                remove: [tag],
                libraryName: libraryName,
            }),
        });

        return await res.json();
    }

    async addListTagItem(
        fileId: string,
        tag: string,
        listType: coreTypes.listType,
        libraryName?: string,
        options?: { originalHostname?: string; accessToken?: string }
    ) {
        // eslint-disable-next-line max-len
        const url = `${process.env.IS_SSR_LOCAL_QUERY_ENDPOINT || ''}/api/admin/${listType}/add/tags`;
        const res = await fetch(url, {
            method: 'POST',
            headers: this.getHeaders(
                {
                    'Content-Type': 'application/json',
                },
                options
            ),
            body: JSON.stringify({
                fileId: fileId,
                add: [tag],
                libraryName: libraryName,
            }),
        });

        return await res.json();
    }
}
